import { render, staticRenderFns } from "./AVehicleHeader.vue?vue&type=template&id=394cb15c&scoped=true"
import script from "./AVehicleHeader.vue?vue&type=script&lang=js"
export * from "./AVehicleHeader.vue?vue&type=script&lang=js"
import style0 from "./AVehicleHeader.vue?vue&type=style&index=0&id=394cb15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394cb15c",
  null
  
)

export default component.exports